import baseProps from "./baseProps.js";

const baseNonTextProps = { ...baseProps };

delete baseNonTextProps.placeholder;

export default baseNonTextProps;
